import { api } from '@/api/client';
import { useSession } from '@/stores/session';

/** 先撤销当前浏览器的推送订阅，再结束共享会话；任何一步失败都不宣称已退出。 */
export async function logoutCurrentDevice() {
  if ('serviceWorker' in navigator) {
    const registration = await navigator.serviceWorker.getRegistration('/');
    const script = registration?.active?.scriptURL || registration?.waiting?.scriptURL || registration?.installing?.scriptURL;
    // 只处理本项目 V1 的 /sw.js，绝不退订同源其他路径下的项目。
    if (registration && script && new URL(script).pathname === '/sw.js' && new URL(registration.scope).pathname === '/') {
      const subscription = await registration.pushManager?.getSubscription();
      if (subscription) {
        await api.removePushSubscription(subscription.endpoint);
        await subscription.unsubscribe();
      }
    }
  }
  await api.logout();
  useSession.setState({ status: 'anon', user: null });
}
